<template>
    <div>
        
        <!-- 積溫 -->
        <div class="card-subtitle mb-2" v-if="cgp_list && cgp_data">

            <h4 v-if="show_title">{{ $t('menu.crop_growth_progress') }}</h4>

            <b-progress :max="cgp_data.total_bar" class="mb-3 progressbar-bg">

                <template v-for="(cgp, idx) in cgp_list">
                    <!-- Progress Bar 彩色 已完成進度調 -->
                    <b-progress-bar :key="idx"
                                    :id="'cgp-' + idx"
                                    v-if="cgp.period_bar[0] > 0"
                                    :class="'cgp cgp-'+idx"
                                    :value="cgp.period_bar[0]">
                        {{ cgp.period[0] }}
                    </b-progress-bar>
                    <!-- Progress Bar 灰色 未來進度調 -->
                    <b-progress-bar :key="idx + '-future'"
                                    :id="'cgp-future-' + idx"
                                    v-if="cgp.period_bar[1] > 0"
                                    :class="'cgp cgp-future'"
                                    :value="cgp.period_bar[1]">
                        {{ cgp.period[1] }}
                    </b-progress-bar>
                </template>

            </b-progress>

            <template v-for="(cgp, idx) in cgp_list">
                <!-- Tooltip 已完成區域 -->
                <b-tooltip  :key="idx"
                            :target="'cgp-' + idx"
                            v-if="cgp.period_bar[0] > 0"
                            placement="bottom">
                    <div class="tooltip-title">
                        <template v-if="cgp.name[ user_language ]">{{ cgp.name[ user_language ] }}</template>
                        <template v-else>{{ cgp.name.en }}</template>
                    </div>
                    <div class="tooltip-title-sub"> {{ cgp.period[0] + ' ' + $t('u.days') }} </div>
                    <div class="tooltip-description" v-if="cgp.definition">
                        <template v-if="cgp.definition[ user_language ]">{{ cgp.definition[ user_language ] }}</template>
                        <template v-else>{{ cgp.definition.en }}</template>
                    </div>
                </b-tooltip>
                <!-- Tooltip 未來區域的 -->
                <b-tooltip  :key="idx + '-future'"
                            :target="'cgp-future-' + idx"
                            v-if="cgp.period_bar[1] > 0"
                            placement="bottom">
                    <div class="tooltip-title">
                        <template v-if="cgp.name[ user_language ]">{{ cgp.name[ user_language ] }}</template>
                        <template v-else>{{ cgp.name.en }}</template>
                    </div>
                    <div class="tooltip-title-sub">
                        {{ $t('menu.days_left') }}：
                        <template v-if="cgp.tolerance">
                            {{ ( cgp.period[1] - cgp.tolerance > 0 ? cgp.period[1] - cgp.tolerance
                            : 0 ) }} ~ {{ cgp.period[1] + cgp.tolerance }} {{ $t('u.days') }}
                        </template>
                        <template v-else>
                            {{ cgp.period[1] + ' ' + $t('u.days') }}
                        </template>
                    </div>
                    <div class="tooltip-description" v-if="cgp.definition">
                        <!-- <template v-if="cgp.definition[ user_language ]">{{ cgp.definition[ user_language ] }}</template>
                        <template v-else>{{ cgp.definition.en }}</template> -->
                    </div>
                </b-tooltip>
            </template>

        </div><!-- 積溫 END -->

    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        data_growth_period: {
            type: Array,
        },
        show_title: {
            type: Boolean,
            default: true,
        },
    },
    components: {
    },
    data () {
        return {
            cgp_data: undefined,
            cgp_list: undefined,
            cgp_now: undefined,
        }
    },
    mounted () {
        this.compute_Stage()
    },
    computed: {
        ...mapState({
            'user_language': state => state.user.language,
        }),

    },
    watch: {

        data_growth_period (val, newVal)
        {
            if ( val )
            {
                this.compute_Stage()
            }
        },

    },
    methods: {

        emit ()
        {
            this.$emit('cgp-data', this.cgp_data);
            this.$emit('cgp-list', this.cgp_list);
            this.$emit('cgp-now', this.cgp_now);
        },

        // 取得現在的生長階段
        get_StageNow ()
        {
            if (this.cgp_list && this.cgp_list.length > 0 && this.cgp_data)
            {
                let _info = {
                    name: undefined,
                    definition: undefined,
                    period: [ undefined, undefined ],
                    count_past: 0,
                    count_future: 0,
                    count_total: this.cgp_data.total,
                    next: undefined,
                }
                this.cgp_list.forEach( (_cgp, _idx) => {
                    if (_cgp.period[0] > 0)
                    {
                        _info.name = _cgp.name
                        _info.definition = _cgp.definition
                        _info.period = _cgp.period
                        _info.count_past += _cgp.period[0]

                        if ( _idx < this.cgp_list.length-1 )
                        {
                            _info.next = {
                                name: this.cgp_list[ _idx + 1 ].name,
                                day_next: _cgp.period[1]
                            }
                        }
                        else _info.next = undefined
                    }
                })
                this.cgp_now = _info
            }
            else
            {
                this.cgp_now = undefined
            }
        },

        // 處理生長階段的計算
        compute_Stage ()
        {
            this.cgp_data = { 'growth_period': this.data_growth_period }
            // this.$store.commit('cropperiod/setGrowthPeriodBar', this.cgp_data)
            this.set_GrowthPeriodBar( this.cgp_data )
            this.cgp_list = this.cgp_data.growth_period

            this.get_StageNow()
            this.emit()
        },

        // 繪製成彩色 bar 前的計算
        set_GrowthPeriodBar (_data)
        {
            let _total = 0;
            let _total_bar = 0;
            let _bar_min_width = 0;

            // 先加總一下
            _data.growth_period.forEach( _stage => {
                _total += _stage.period[0] + _stage.period[1];
            })

            // 指定最小寬度至少為 Bar 總寬的 1/12，看起來才不會太細窄
            _bar_min_width = parseInt( _total / 12 );

            _data.growth_period.forEach( _stage => {
                _stage.period_bar = [ _stage.period[0], _stage.period[1] ];

                if ( _stage.period_bar[0] > 0 && _stage.period_bar[0] < _bar_min_width )
                {
                    _stage.period_bar[0] = _bar_min_width
                }
                if ( _stage.period_bar[1] > 0 && _stage.period_bar[1] < _bar_min_width )
                {
                    _stage.period_bar[1] = _bar_min_width
                }

                // 最後加總一下
                _total_bar += _stage.period_bar[0] + _stage.period_bar[1];
            })

            _data.total = _total;
            _data.total_bar = _total_bar;
        },

    }
}
</script>